import { render } from "./ProviderPage.vue?vue&type=template&id=0d9272aa&scoped=true&ts=true"
import script from "./ProviderPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProviderPage.vue?vue&type=script&lang=ts&setup=true"

import "./ProviderPage.vue?vue&type=style&index=0&id=0d9272aa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d9272aa"],['__file',"src/pages/settings/pages/provider/ProviderPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0d9272aa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0d9272aa', __exports__)) {
    api.reload('0d9272aa', __exports__)
  }
  
  module.hot.accept("./ProviderPage.vue?vue&type=template&id=0d9272aa&scoped=true&ts=true", () => {
    api.rerender('0d9272aa', render)
  })

}


export default __exports__